"use strict";
exports.__esModule = true;
exports.SDK_SPLIT_RENT_WINDOW = void 0;
exports.SDK_SPLIT_RENT_WINDOW = {
    HIDDEN: "Don't see it?",
    NOTICE: "You're splitting rent with Flex in another window.",
    CTA: 'Open Flex'
};
